import React, { Component, useContext, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import {
	Grid,
} from "@material-ui/core";


// import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";
import InfoTooltip from "../general/InfoTooltip";
import CreditSelectField from './fields/CreditSelectField';
import CreditTextField from './fields/CreditTextField';
import CreditEuroField from "./fields/CreditEuroField";
import CreditPercentField from "./fields/CreditPercentField";
import CreditIBANField from "./fields/CreditIBANField";
import CreditMonthField from "./fields/CreditMonthField";
import CreditDateField from "./fields/CreditDateField";
import CreditPriceTableField from './fields/CreditPriceTableField';
import CreditSwitchField from './fields/CreditSwitchField';
import CreditBankAustriaCustomerField from './fields/CreditBankAustriaCustomerField';


const useStyles = makeStyles((theme) => ({

}));


export default function CreditField(
	{
		setMetafieldsValues,
		resolvePlaceholders,
		channelDisplayNames,
		metafieldsForCurrentMetaKey,
		fieldConfigs,
		meta_key,
		xs,
		md,
		fieldlayout,
		credit,
		view = "app" // "app" or "portal"
	}) {
	const theme = useTheme();
	const classes = useStyles();
	// const pageContext = useContext(PageContext);
	const userContext = useContext(UserContext);
	// value im State ist nicht die Lösung, da es mehrere Values geben kann. Vom Prinzip her sollte es aber so sein, dass hier in der Komponente der Wert sofort aktualisiert wird und dann erst oberhalb
	// const [value, setValue] = useState(null);

	useEffect(() => {

	}, [metafieldsForCurrentMetaKey]);


	const renderSelectField = (fieldConfig, currentMetafields, hideChannels = false) => {
		return (
			<CreditSelectField
				fieldConfig={fieldConfig}
				currentMetafields={currentMetafields}
				hideChannels={hideChannels}
				channelDisplayNames={channelDisplayNames}
				setMetafieldsValues={setMetafieldsValues}
				resolvePlaceholders={resolvePlaceholders}
				labelPosition={fieldlayout === "label_before" ? "before" : "floating"}
			/>
		);
	}


	const renderFieldLayoutPriceTable = (fieldConfig, currentMetafields, hideChannels = false, fieldLayout = "pricetable") => {
		return (
			<CreditPriceTableField
				key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
				fieldConfig={fieldConfig}
				currentMetafields={currentMetafields}
				hideChannels={hideChannels}
				channelDisplayNames={channelDisplayNames}
				setMetafieldsValues={setMetafieldsValues}
				showCurrency={fieldLayout == "pricetable"}
			/>
		);
	}


	const renderFieldLayoutMonths = (fieldConfig, currentMetafields, innerFieldWidth, hideChannels = false, fieldlayout = "months") => {
		return <CreditMonthField
			key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
			fieldConfig={fieldConfig}
			currentMetafields={currentMetafields}
			hideChannels={hideChannels}
			channelDisplayNames={channelDisplayNames}
			setMetafieldsValues={setMetafieldsValues}
			innerFieldWidth={innerFieldWidth}
			showFullYearsOnly={fieldlayout === "years_in_months"}
		/>
	}


	const renderFieldLayoutBankAustriaCustomer = (fieldConfig, currentMetafields) => {
		return (
			<CreditBankAustriaCustomerField
				key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
				fieldConfig={fieldConfig}
				currentMetafields={currentMetafields}
				setMetafieldsValues={setMetafieldsValues}
				resolvePlaceholders={resolvePlaceholders}
				credit={credit}
			/>
		);
	}

	const renderTextField = (fieldConfig, currentMetafields, hideChannels = false) => {
		if (fieldlayout === "iban")
			return (
				<CreditIBANField
					key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
					fieldConfig={fieldConfig}
					currentMetafields={currentMetafields}
					hideChannels={hideChannels}
					channelDisplayNames={channelDisplayNames}
					setMetafieldsValues={setMetafieldsValues}
				/>
			);
		if (fieldlayout === "euro")
			return (
				<CreditEuroField
					key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
					fieldConfig={fieldConfig}
					currentMetafields={currentMetafields}
					hideChannels={hideChannels}
					channelDisplayNames={channelDisplayNames}
					setMetafieldsValues={setMetafieldsValues}
				/>
			);
		if (fieldlayout === "percent")
			return (
				<CreditPercentField
					key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
					fieldConfig={fieldConfig}
					currentMetafields={currentMetafields}
					hideChannels={hideChannels}
					channelDisplayNames={channelDisplayNames}
					setMetafieldsValues={setMetafieldsValues}
				/>
			);
		return (
			<CreditTextField
				key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
				fieldConfig={fieldConfig}
				currentMetafields={currentMetafields}
				hideChannels={hideChannels}
				channelDisplayNames={channelDisplayNames}
				setMetafieldsValues={setMetafieldsValues}
				resolvePlaceholders={resolvePlaceholders}
				fieldlayout={fieldlayout}
			/>
		);
	}


	const renderDateField = (fieldConfig, currentMetafields, hideChannels = false) => {
		return (
			<CreditDateField
				key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
				fieldConfig={fieldConfig}
				currentMetafields={currentMetafields}
				hideChannels={hideChannels}
				channelDisplayNames={channelDisplayNames}
				setMetafieldsValues={setMetafieldsValues}
			/>
		);
	}

	const renderSwitchField = (fieldConfig, currentMetafields, hideChannels = false) => {
		return (
			<CreditSwitchField
				key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_")}
				fieldConfig={fieldConfig}
				currentMetafields={currentMetafields}
				hideChannels={hideChannels}
				channelDisplayNames={channelDisplayNames}
				setMetafieldsValues={setMetafieldsValues}
			/>
		);
	}


	if (!meta_key)
		return <></>;


	// leere fieldConfig bedeutet, dass dieses Feld in keinem Channel (mehr) verwendet wird
	// oder aufgrund von conditions im Moment nicht sichtbar ist
	if (!fieldConfigs || fieldConfigs.length === 0)
		return null;

	let innerFieldWidth = 12;

	if ((!md && !xs) || (md && md >= 6) || (!md && xs && xs >= 8)) {
		// lege nur Spalten an wenn der Wrapper mindestens 8 Spalten breit ist
		if (fieldConfigs.length === 1)
			innerFieldWidth = 12;
		else if (fieldConfigs.length === 2)
			innerFieldWidth = 6;
		else
			innerFieldWidth = 4
	}

	return (
		<Grid item xs={xs ? xs : 12} md={md ? md : xs ? xs : 12}>
			<Grid container spacing={2}>
				{fieldConfigs.map(fieldConfig => {
					// das metafield objekt
					let currentMetafields = metafieldsForCurrentMetaKey;
					if (view === "app") {
						currentMetafields = metafieldsForCurrentMetaKey.filter(metafield =>
							fieldConfig.channels.includes(metafield.channel)
						)
					}
					if (!currentMetafields || currentMetafields.length === 0)
						return null;

					const hideChannels = view === "portal" || userContext.user.role === "tippgeber" || fieldConfigs.length === 1 && fieldConfig.channels.includes('GLOBAL');
					switch (fieldConfig.field_type) {
						case "STRING_ENUM":
						case "INT_ENUM":
							return (
								<Grid item xs={12} md={innerFieldWidth} key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_") + "-wrap"}>
									{renderSelectField(fieldConfig, currentMetafields, hideChannels)}
									{
										fieldConfig.description && fieldlayout !== "label_before" &&
										<InfoTooltip
											variant="small"
											content={fieldConfig.description}
										/>
									}
								</Grid>);
						case "STRING":
						case "INT":
						case "FLOAT":
							if (fieldlayout && (fieldlayout === "pricetable" || fieldlayout === "pricetable_without_currency"))
								return renderFieldLayoutPriceTable(fieldConfig, currentMetafields, hideChannels, fieldlayout)
							if (fieldlayout && fieldlayout === "months" || fieldlayout === "years_in_months")
								return renderFieldLayoutMonths(fieldConfig, currentMetafields, innerFieldWidth, hideChannels, fieldlayout)
							if (fieldlayout && fieldlayout === "bankaustriacustomer")
								return renderFieldLayoutBankAustriaCustomer(fieldConfig, currentMetafields)
							return (
								<Grid item xs={12} md={innerFieldWidth} key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_") + "-wrap"}>
									{renderTextField(fieldConfig, currentMetafields, hideChannels)}
									{
										fieldConfig.description && fieldlayout !== "label_before" &&
										<InfoTooltip
											variant="small"
											content={fieldConfig.description}
										/>
									}
								</Grid>);
						case "DATE":
							return (
								<Grid item xs={12} md={innerFieldWidth} key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_") + "-wrap"}>
									{renderDateField(fieldConfig, currentMetafields, hideChannels)}
									{
										fieldConfig.description &&
										<InfoTooltip
											variant="small"
											content={fieldConfig.description}
										/>
									}
								</Grid>);
						case "BOOLEAN":
							return (
								<Grid item xs={12} md={innerFieldWidth} key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_") + "-wrap"}>
									{renderSwitchField(fieldConfig, currentMetafields, hideChannels)}
									{" "}
									{
										fieldConfig.description &&
										<InfoTooltip
											variant="small"
											content={fieldConfig.description}
										/>
									}
								</Grid>);
					}
				})}
			</Grid>
		</Grid>
	);
}
